export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Cadastros',
    icon: 'FileTextIcon',
    access_nivel: [2, 6],
    children: [
      {
        title: 'Usuários',
        route: 'list-users',
        access_nivel: [2, 6],
      },
      {
        title: 'Unidades',
        route: 'list-units',
        access_nivel: [2, 6],
      },
      {
        title: 'Tipos',
        route: 'list-types',
        access_nivel: [2, 6],
      },
      {
        title: 'Motivos',
        route: 'list-reasons',
        access_nivel: [2, 6],
      },
      {
        title: 'Convênios',
        route: 'list-medical-agreements',
        access_nivel: [2, 6],
      },
      // {
      //   title: 'Porta de Entrada',
      //   route: 'list-entrance-doors',
      //   access_nivel: [6],
      // },
      {
        title: 'Agências',
        route: 'list-centrals',
        access_nivel: [2, 6],
      },
      {
        title: 'Equipes',
        route: 'list-teams',
        access_nivel: [2, 6],
      },
    ],
  },
  {
    title: 'VideoWall',
    route: 'list-video-wall',
    icon: 'TvIcon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Ocorrências em Andamento',
    route: 'list-occurrence-progress',
    icon: 'HeartIcon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Ocorrências Finalizadas',
    route: 'list-occurrence-finished',
    icon: 'CheckIcon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Relatórios',
    route: 'list-reports',
    icon: 'BarChart2Icon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Suporte Técnico',
    route: 'list-help-desk',
    icon: 'HelpCircleIcon',
    access_nivel: [1, 2, 3, 6],
  },
  {
    title: 'Logs de Acesso',
    route: 'list-log-access',
    icon: 'AlertTriangleIcon',
    access_nivel: [2, 6],
  },
]
